/**
 * Created By Elia Rohana on 12/3/18
 */

import { Action } from '@ngrx/store';

export enum NodesConfigurationsActionTypes {
    NODE_CONFIGURATION_CREATED = '[node configuration] configuration created',
    NODE_CONFIGURATION_EDITED = '[node configuration] configuration edited',

}

export class ConfigurationCreated implements Action {
    readonly type = NodesConfigurationsActionTypes.NODE_CONFIGURATION_CREATED;
    constructor(public payload: { nodeId: string, configurations: string}) { }
}

export class ConfigurationEdited implements Action {
    readonly type = NodesConfigurationsActionTypes.NODE_CONFIGURATION_EDITED;
    constructor(public payload: { nodeId: string, configurations: string}) { }
}



export type NodeConfigurationsAction = ConfigurationCreated | ConfigurationEdited;
